import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { Roles } from '~/data/user/role';
import { getRestrictedWidgetsRolesOptions } from '~/scenes/MyWorkspace/components/Widgets/data';
import {
  WorkspaceSetupFormSettings,
  WorkspaceSetupMode,
  getEmptyWorkspaceSettings,
} from '~/scenes/MyWorkspace/components/WorkspaceToolbar/components/WorkspaceToolbarReadMode/components/WorkspaceSetupDialog';
import { enterManageWorkspace } from '~/scenes/MyWorkspace/layoutSlice';
import { WorkspaceSettings } from '~/scenes/MyWorkspace/userSettings';

type PropsType = {
  formSettings: WorkspaceSetupFormSettings | undefined;
};

type UseWorkspaceSetupFormOutput = {
  formMode: WorkspaceSetupMode;
  initialWorkspaceSettings: WorkspaceSettings;
  createWorkspace: (workspaceSettings: WorkspaceSettings) => void;
  restrictedRolesOptions: Roles[];
};

export const useWorkspaceSetupForm = (
  props: PropsType,
): UseWorkspaceSetupFormOutput => {
  const dispatch = useDispatch();

  const { formSettings } = props;

  const initialWorkspaceSettings = useMemo(() => {
    return formSettings?.payload || getEmptyWorkspaceSettings();
  }, [formSettings]);

  const formMode = useMemo(() => {
    return formSettings?.mode || WorkspaceSetupMode.Create;
  }, [formSettings]);

  const createWorkspace = useCallback(
    (workspaceSettings: WorkspaceSettings) => {
      dispatch(enterManageWorkspace(workspaceSettings));
    },
    [dispatch],
  );

  const restrictedRolesOptions: Roles[] = useMemo(
    () => getRestrictedWidgetsRolesOptions('all'),
    [],
  );

  return {
    formMode,
    initialWorkspaceSettings,
    createWorkspace,
    restrictedRolesOptions,
  };
};
